import * as Y from "yjs"
import { ValidationNodeDto } from "@store/services/documentService"
import { FetchBaseQueryError } from "@reduxjs/toolkit/dist/query/react"
import { GraphDocument } from "@features/builder/types"
import { sha256 } from "js-sha256"

export const getValidationHash = async (doc: GraphDocument, endDate: string): Promise<string> => {
  // casting to Y.Doc because we are shadowing types
  const update = Y.encodeStateAsUpdate(doc as Y.Doc)
  const endArr = new TextEncoder().encode(endDate)
  const arr = new Uint8Array(update.length + endArr.length)
  arr.set(endArr, 0)
  arr.set(update, endArr.length)
  return sha256(arr)
}

export const getValidationNodesFromDoc = (
  doc: GraphDocument,
): { [key: string]: ValidationNodeDto } => {
  const nodes: { [key: string]: ValidationNodeDto } = {}
  doc
    .getMap("graph")
    .get("nodes")
    ?.forEach((n: Y.Text) => {
      const node = JSON.parse(n.toString())
      const { meta } = node.data
      const data: ValidationNodeDto = {}
      if (meta["Forecast Mnem"]) data["Forecast Mnem"] = meta["Forecast Mnem"]
      if (meta["Scenario Mnem"]) data["Scenario Mnem"] = meta["Scenario Mnem"]
      if (meta["Historic Mnem"]) data["Historic Mnem"] = meta["Historic Mnem"]
      if (Object.keys(data).length > 0) nodes[node.id] = data
    })
  return nodes
}

export const formatValidationServerError = (error: FetchBaseQueryError) => {
  if ("error" in error) return `${error.status} ${error?.error ?? ""}`
  return `${error.status} backend communication error`
}
